export default __webpack_public_path__ + "static/media/calendar-icon.9586a4ac.svg";